// extracted by mini-css-extract-plugin
var _1 = "SwapMyBox_actionsContainer__poOZU";
var _2 = "SwapMyBox_contactToUnswap__6CrFk";
var _3 = "SwapMyBox_disclaimer__Pr9wJ";
var _4 = "SwapMyBox_faqAnswer__kXMc0";
var _5 = "SwapMyBox_faqContainer__GHxaw";
var _6 = "SwapMyBox_faqQuestion__TK9K-";
var _7 = "SwapMyBox_faqTitle__pw5Uq";
var _8 = "SwapMyBox_mainContent__Y2EOJ";
var _9 = "SwapMyBox_mainContentContainer__teirD";
var _a = "SwapMyBox_mainText__Cdle1";
var _b = "SwapMyBox_mainTextItem__x9PAd";
var _c = "768px";
var _d = "SwapMyBox_mobileImage__XDPQf";
var _e = "SwapMyBox_seeDetails__5nFa0";
var _f = "'../../shared.module.css'";
var _10 = "SwapMyBox_stillQuestions__v8mPb";
var _11 = "SwapMyBox_swapForCredit__7V6Z2";
var _12 = "SwapMyBox_swapMyBoxContainer__EdpBj";
var _13 = "SwapMyBox_swappedDate__KJG2r";
var _14 = "SwapMyBox_title__Ej8BZ";
var _15 = "SwapMyBox_visitFaq__Cmh6A";
export { _1 as "actionsContainer", _2 as "contactToUnswap", _3 as "disclaimer", _4 as "faqAnswer", _5 as "faqContainer", _6 as "faqQuestion", _7 as "faqTitle", _8 as "mainContent", _9 as "mainContentContainer", _a as "mainText", _b as "mainTextItem", _c as "md", _d as "mobileImage", _e as "seeDetails", _f as "shared", _10 as "stillQuestions", _11 as "swapForCredit", _12 as "swapMyBoxContainer", _13 as "swappedDate", _14 as "title", _15 as "visitFaq" }
